export default __webpack_public_path__ + "static/wisr-app-qr-code-925d988c125a4ebac343c744d5646421.svg";